/**
 * HeldStatusLabel — the push status while the tracker's own switch (or the
 * global one) holds its optimizer: amber "Held", never "Pushes active". The
 * reason sits behind the label's tooltip (calm one-liner).
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';

import { Tooltip } from '@/components/ui/Tooltip';

export interface HeldStatusLabelProps {
  /** Tracker display name, e.g. "Tres Commas". */
  tracker: string;
  reason: string;
}

const HeldStatusLabel: FC<HeldStatusLabelProps> = ({ tracker, reason }) => (
  <>
    <span
      className="h-1.5 w-1.5 shrink-0 rounded-full bg-warning shadow-[0_0_0_2px_rgba(245,158,11,0.18)]"
      aria-hidden
    />
    <Tooltip
      side="bottom"
      contentClassName="max-w-sm"
      content={
        <span className="block space-y-1">
          <span className="block font-medium">{reason}</span>
          <span className="block">Apply and the scheduler push nothing to {tracker} while it is held.</span>
        </span>
      }
    >
      <span className="cursor-help text-[11px] font-medium leading-none text-warning">Held</span>
    </Tooltip>
  </>
);

export default HeldStatusLabel;
